import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';

import { AccountLicenseCheck } from '../validators/account-license-check.validator';

@Directive({
    selector: '[licenseCheck]',
    providers: [{ provide: NG_VALIDATORS, useExisting: LicenseCheckDirective, multi: true }]
})
export class LicenseCheckDirective implements Validator {

    validate(formGroup: FormGroup): ValidationErrors {
        return AccountLicenseCheck()(formGroup);
    }
}